import InfoCard from './InfoCard.view';
export default InfoCard;
